import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { IEmployee } from '../../model/employee'
import { EmployeeListComponent } from '../employee-list/employee-list.component';
import { EmployeeService } from '../../services/employee.service';
import { NgModule } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, Validators, } from '@angular/forms'


@Component({
  selector: 'app-edit-employee',
  templateUrl: './edit-employee.component.html',
  styleUrls: ['./edit-employee.component.scss']
})
export class EditEmployeeComponent implements OnInit {
  public formSubmitAttempt: boolean;
  registertionImage: string;// = require("../../../assets/images/profile.jpg");
  files: FileList;
  documentfiles: File;
  dob;
  signupForm: FormGroup;
  FirstName: string = "";
  LastName: string = "";
  Email: string = "";
  Password: string = "";
  currencyType: string = "Kenya Shillings – KES"
  userId : any;
  private countryCode: string;
  private homecountryCode: string;
  private workcountryCode: string;
  private setmobile: string;
  private sethome: string;
  private setwork: string;
  isSlide: boolean = false;
  EditForm: FormGroup;
  selectedDoctor: IEmployee;
  employeeProfileImage : any;
  currencyList = [{ value: 'USD', option: 'America (United States) Dollars – USD' },
  { value: 'AFN', option: 'Afghanistan Afghanis – AFN' },
  { value: 'ALL', option: 'Albania Leke – ALL' },
  { value: 'DZD', option: 'Algeria Dinars – DZD' },
  { value: 'ARS', option: 'Argentina Pesos – ARS' },
  { value: 'AUD', option: 'Australia Dollars – AUD' },
  { value: 'ATS', option: 'Austria Schillings – ATS' },

  { value: 'BSD', option: 'Bahamas Dollars – BSD' },
  { value: 'BHD', option: 'Bahrain Dinars – BHD' },
  { value: 'BDT', option: 'Bangladesh Taka – BDT' },
  { value: 'BBD', option: 'Barbados Dollars – BBD' },
  { value: 'BEF', option: 'Belgium Francs – BEF' },
  { value: 'BMD', option: 'Bermuda Dollars – BMD' },

  { value: 'BRL', option: 'Brazil Reais – BRL' },
  { value: 'BGN', option: 'Bulgaria Leva – BGN' },
  { value: 'CAD', option: 'Canada Dollars – CAD' },
  { value: 'XOF', option: 'CFA BCEAO Francs – XOF' },
  { value: 'XAF', option: 'CFA BEAC Francs – XAF' },
  { value: 'CLP', option: 'Chile Pesos – CLP' },

  { value: 'CNY', option: 'China Yuan Renminbi – CNY' },
  { value: 'CNY', option: 'RMB (China Yuan Renminbi) – CNY' },
  { value: 'COP', option: 'Colombia Pesos – COP' },
  { value: 'XPF', option: 'CFP Francs – XPF' },
  { value: 'CRC', option: 'Costa Rica Colones – CRC' },
  { value: 'HRK', option: 'Croatia Kuna – HRK' },

  { value: 'CYP', option: 'Cyprus Pounds – CYP' },
  { value: 'CZK', option: 'Czech Republic Koruny – CZK' },
  { value: 'DKK', option: 'Denmark Kroner – DKK' },
  { value: 'DEM', option: 'Deutsche (Germany) Marks – DEM' },
  { value: 'DOP', option: 'Dominican Republic Pesos – DOP' },
  { value: 'NLG', option: 'Dutch (Netherlands) Guilders – NLG' },

  { value: 'XCD', option: 'Eastern Caribbean Dollars – XCD' },
  { value: 'EGP', option: 'Egypt Pounds – EGP' },
  { value: 'EEK', option: 'Estonia Krooni – EEK' },
  { value: 'EUR', option: 'Euro – EUR' },
  { value: 'FJD', option: 'Fiji Dollars – FJD' },
  { value: 'FIM', option: 'Finland Markkaa – FIM' },

  { value: 'FRF', option: '>France Francs – FRF*' },
  { value: 'DEM', option: 'Germany Deutsche Marks – DEM' },
  { value: 'XAU', option: 'Gold Ounces – XAU' },
  { value: 'GRD', option: 'Greece Drachmae – GRD' },
  { value: 'GTQ', option: 'Guatemalan Quetzal – GTQ' },
  { value: 'NLG', option: 'Holland (Netherlands) Guilders – NLG' },
  { value: 'HKD', option: 'Hong Kong Dollars – HKD' },

  { value: 'HUF', option: 'Hungary Forint – HUF' },
  { value: 'ISK', option: 'Iceland Kronur – ISK' },
  { value: 'XDR', option: 'IMF Special Drawing Right – XDR' },
  { value: 'INR', option: 'India Rupees – INR' },
  { value: 'IDR', option: 'Indonesia Rupiahs – IDR' },
  { value: 'IRR', option: 'Iran Rials – IRR' },

  { value: 'IQD', option: 'Iraq Dinars – IQD' },
  { value: 'IEP', option: 'Ireland Pounds – IEP*' },
  { value: 'ILS', option: 'Israel New Shekels – ILS' },
  { value: 'ITL', option: 'Italy Lire – ITL*' },
  { value: 'JMD', option: 'Jamaica Dollars – JMD' },
  { value: 'JPY', option: 'Japan Yen – JPY' },

  { value: 'JOD', option: 'Jordan Dinars – JOD' },
  { value: 'KES', option: 'Kenya Shillings – KES' },
  { value: 'KRW', option: 'Korea (South) Won – KRW' },
  { value: 'KWD', option: 'Kuwait Dinars – KWD' },
  { value: 'LBP', option: 'Lebanon Pounds – LBP' },
  { value: 'LUF', option: 'Luxembourg Francs – LUF' },

  { value: 'MYR', option: 'Malaysia Ringgits – MYR' },
  { value: 'MTL', option: 'Malta Liri – MTL' },
  { value: 'MUR', option: 'Mauritius Rupees – MUR' },
  { value: 'MXN', option: 'Mexico Pesos – MXN' },
  { value: 'MAD', option: 'Morocco Dirhams – MAD' },
  { value: 'NLG', option: 'Netherlands Guilders – NLG' },

  { value: 'NZD', option: 'New Zealand Dollars – NZD' },
  { value: 'NOK', option: 'Norway Kroner – NOK' },
  { value: 'OMR', option: 'Oman Rials – OMR' },
  { value: 'PKR', option: 'Pakistan Rupees – PKR' },
  { value: 'XPD', option: 'Palladium Ounces – XPD' },
  { value: 'PEN', option: 'Peru Nuevos Soles – PEN' },

  { value: 'PHP', option: 'Philippines Pesos – PHP' },
  { value: 'XPT', option: 'Platinum Ounces – XPT' },
  { value: 'PLN', option: 'Poland Zlotych – PLN' },
  { value: 'PTE', option: 'Portugal Escudos – PTE' },
  { value: 'QAR', option: 'Qatar Riyals – QAR' },
  { value: 'RON', option: 'Romania New Lei – RON' },

  { value: 'ROL', option: 'Romania Lei – ROL' },
  { value: 'RUB', option: 'Russia Rubles – RUB' },
  { value: 'SAR', option: 'Saudi Arabia Riyals – SAR' },
  { value: 'XAG', option: 'Silver Ounces – XAG' },
  { value: 'SGD', option: 'Singapore Dollars – SGD' },
  { value: 'SKK', option: 'Slovakia Koruny – SKK' },

  { value: 'SIT', option: 'Slovenia Tolars – SIT' },
  { value: 'ZAR', option: 'South Africa Rand – ZAR' },
  { value: 'KRW', option: 'South Korea Won – KRW' },
  { value: 'ESP', option: 'Spain Pesetas – ESP' },
  { value: 'XDR', option: 'Special Drawing Rights (IMF) – XDR' },
  { value: 'LKR', option: 'Sri Lanka Rupees – LKR' },

  { value: 'SDD', option: 'Sudan Dinars – SDD' },
  { value: 'SEK', option: 'Sweden Kronor – SEK' },
  { value: 'CHF', option: 'Switzerland Francs – CHF' },
  { value: 'TWD', option: 'Taiwan New Dollars – TWD' },
  { value: 'THB', option: 'Thailand Baht – THB' },
  { value: 'TTT', option: '>Trinidad and Tobago Dollars – TTD' },

  { value: 'TND', option: 'Tunisia Dinars – TND' },
  { value: 'TRY', option: 'Turkey New Lira – TRY' },
  { value: 'AED', option: 'United Arab Emirates Dirhams – AED' },
  { value: 'GBP', option: 'United Kingdom Pounds – GBP' },
  { value: 'USD', option: 'United States Dollars – USD' },
  { value: 'VEB', option: 'Venezuela Bolivares – VEB' },

  { value: 'VND', option: 'Vietnam Dong – VND' },
  { value: 'ZMK', option: 'Zambia Kwacha – ZMK' },]
  constructor(private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder) {
    this.EditForm = fb.group({
      firstName: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],
      lastName: ['', [Validators.required, Validators.maxLength(19)]],
      email: ['', [
        Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
      ]],
      mobile: ['', [Validators.required, Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      home: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      work: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      specialityYear: [],
      degreeDesignation: [],
      currentRegistration: [],
      registrationNumber: [],
      licensingBody: [],
      yearRegistered: [],
      city: [],
      speciality: [],
      //dob:[],
      documentfiles: [],
      institution: [],
      specialInterest: [],
      imagefile: [],
      currencyType: [],
      consultationcharges: [],
      countrycode: [],
      homecountrycode: [],
      workcountrycode: [],

    })

  }

  ngOnInit() {
    this.selectedDoctor = this._employeeService.getEmpleeData();
    if (this.selectedDoctor) {
      this.userId = this.selectedDoctor.id;
      if(this.selectedDoctor.profileImage.includes(this.userId)){
        this.employeeProfileImage = this.selectedDoctor.profileImage;
      }
      else{
        this.employeeProfileImage = null;
      }
      this.countryCode = (this.selectedDoctor.countryCode == '' || this.selectedDoctor.countryCode == null) ? "254" : this.selectedDoctor.countryCode
      this.homecountryCode = (this.selectedDoctor.homeCountryCode == '' || this.selectedDoctor.homeCountryCode == null) ? "254" : this.selectedDoctor.homeCountryCode
      this.workcountryCode = (this.selectedDoctor.workcountryCode == '' || this.selectedDoctor.workcountryCode == null) ? "254" : this.selectedDoctor.workcountryCode

      this.setmobile = (this.selectedDoctor.mobile == null || this.selectedDoctor.mobile == '') ? null : ("+" + ((this.selectedDoctor.countryCode == '' || this.selectedDoctor.countryCode == null) ? "254" : this.selectedDoctor.countryCode) + this.selectedDoctor.mobile)
      this.sethome = (this.selectedDoctor.home == null || this.selectedDoctor.home == '') ? null : ("+" + ((this.selectedDoctor.homeCountryCode == '' || this.selectedDoctor.homeCountryCode == null) ? "254" : this.selectedDoctor.homeCountryCode) + this.selectedDoctor.home)
      this.setwork = (this.selectedDoctor.work == null || this.selectedDoctor.work == '') ? null : ("+" + ((this.selectedDoctor.workcountryCode == '' || this.selectedDoctor.workcountryCode == null) ? "254" : this.selectedDoctor.workcountryCode) + this.selectedDoctor.work)
      this.EditForm.controls['firstName'].setValue(this.selectedDoctor.firstName);
      this.EditForm.controls['lastName'].setValue(this.selectedDoctor.lastName);
      this.EditForm.controls['email'].setValue(this.selectedDoctor.email);
      this.EditForm.controls['mobile'].setValue(this.setmobile);
      this.EditForm.controls['home'].setValue(this.sethome);
      this.EditForm.controls['work'].setValue(this.setwork);
      this.EditForm.controls['specialityYear'].setValue(this.selectedDoctor.specialityYear);
      this.EditForm.controls['degreeDesignation'].setValue(this.selectedDoctor.degreeDesignation);
      this.EditForm.controls['institution'].setValue(this.selectedDoctor.institution);
      this.EditForm.controls['speciality'].setValue(this.selectedDoctor.speciality);
      this.EditForm.controls['currentRegistration'].setValue(this.selectedDoctor.currentRegistration);
      this.EditForm.controls['registrationNumber'].setValue(this.selectedDoctor.registrationNumber);
      this.EditForm.controls['licensingBody'].setValue(this.selectedDoctor.licensingBody);
      this.EditForm.controls['yearRegistered'].setValue(this.selectedDoctor.yearRegistered);
      this.EditForm.controls['specialInterest'].setValue(this.selectedDoctor.specialInterest);
      this.EditForm.controls['city'].setValue(this.selectedDoctor.city);
      this.EditForm.controls['consultationcharges'].setValue(this.selectedDoctor.consultationCharges);
      this.EditForm.controls['currencyType'].setValue(this.selectedDoctor.currencyType);
      this.currencyType = this.selectedDoctor.currencyType;
      this.EditForm.value.id = this.selectedDoctor.id;
    }
    else {
      this.router.navigate(['employeeList']);
    }


  }

  selectCurrency(event: any) {
    this.currencyType = event;
  }

  onDocumentUpload(event: any) {
    let files = [].slice.call(event.target.files);
    this.documentfiles = files;

  }
  updateEmployee(employeeForm: FormGroup) {
    console.log('hitted');
    this.formSubmitAttempt = true;
    employeeForm.value.mobile = (employeeForm.value.mobile == null || employeeForm.value.mobile == "") ? null : (employeeForm.value.mobile.indexOf("+" + this.countryCode) > -1) ? employeeForm.value.mobile.split("+" + this.countryCode)[1] : employeeForm.value.mobile;
    employeeForm.value.home = (employeeForm.value.home == null || employeeForm.value.home == "") ? null : (employeeForm.value.home.indexOf("+" + this.homecountryCode) > -1) ? employeeForm.value.home.split("+" + this.homecountryCode)[1] : employeeForm.value.home;
    employeeForm.value.work = (employeeForm.value.work == null || employeeForm.value.work == "") ? null : (employeeForm.value.work.indexOf("+" + this.workcountryCode) > -1) ? employeeForm.value.work.split("+" + this.workcountryCode)[1] : employeeForm.value.work;
    employeeForm.controls['mobile'].setValue(employeeForm.value.mobile);
    employeeForm.controls['home'].setValue(employeeForm.value.home);
    employeeForm.controls['work'].setValue(employeeForm.value.work);
    employeeForm.value.mobile = (employeeForm.value.mobile == null || employeeForm.value.mobile == "") ? null : (employeeForm.value.mobile.indexOf("+" + this.countryCode) > -1) ? employeeForm.value.mobile.split("+" + this.countryCode)[1] : employeeForm.value.mobile;
    employeeForm.value.home = (employeeForm.value.home == null || employeeForm.value.home == "") ? null : (employeeForm.value.home.indexOf("+" + this.homecountryCode) > -1) ? employeeForm.value.home.split("+" + this.homecountryCode)[1] : employeeForm.value.home;
    employeeForm.value.work = (employeeForm.value.work == null || employeeForm.value.work == "") ? null : (employeeForm.value.work.indexOf("+" + this.workcountryCode) > -1) ? employeeForm.value.work.split("+" + this.workcountryCode)[1] : employeeForm.value.work;

    employeeForm.value.countrycode = this.countryCode;
    employeeForm.value.homecountrycode = this.homecountryCode;
    employeeForm.value.workcountrycode = this.workcountryCode;
    employeeForm.value.usertype = 2;
    employeeForm.value.address = employeeForm.value.city;
    employeeForm.value.nationalId = null;
    employeeForm.value.id = this.selectedDoctor.id;
    employeeForm.value.userid = this.selectedDoctor.id;
    employeeForm.value.profileImageStatus = -1;
    //this.files  = this.employeeProfileImage;
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    employeeForm.value.token = loginUser.token;
    if (employeeForm.invalid) {
      console.log('invalid');
      return;
    }
    else {
      console.log('valid');
      this._employeeService.updateEmployee(employeeForm.value, this.files).subscribe(
        data => {
          if (data.returnCode == 0) {
            this.formSubmitAttempt = false;
            alert("Doctor records updated Sucessfully")
            this.router.navigate(['employeeList']);
          }
          else {
            alert(data.returnMsg)
          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
    }
  }


  //method for uploadin the profile pic of doctor 
  onProfileUpload(event){
    console.log('hitted ', event.target.files[0]);
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        
        const filedata = (event.target as HTMLInputElement).files[0];

    const reader = new FileReader();
    reader.onload = () => {
      this.employeeProfileImage = reader.result as string;
    }
    reader.readAsDataURL(file);

        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
          var form_data = new FormData();
          // file.fieldname == '';
           form_data.append('token', loginUser.token);    
           form_data.append('userId', this.userId); 
           form_data.append('files', file);
           this._employeeService.uploadDoctorProfilePicture(form_data).subscribe(
            data => {
                if (data.returnCode == "00") {
                    alert("Document uploaded sucessfully")         
                }
                else {
                    alert(data.returnMsg);  
                }
            },
            error => {
                // this.alertService.error(error);
                // this.loading = false;         
                alert(error)
                console.log(error)
            });
      }
   
  }


  reset() {
    this.formSubmitAttempt = false;
    this.router.navigate(['employeeList']);
  }

  onFileChange(event: any) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        this.EditForm.get('imagefile').setValue({
          filename: file.name,
          filetype: file.type,
          // value: reader['result'].split(',')[1],
          fieldname: "imagefile"
        })
      };
    }
  }

  telInputObject(obj: any) {
    console.log(obj);
    obj.intlTelInput('setCountry', 'ke');

  }



  onCountryChange(obj: any) {
    var oldcountry = this.countryCode
    this.countryCode = obj.dialCode
    this.setmobile = (this.EditForm.value.mobile == null || this.EditForm.value.mobile == "") ? null : (this.EditForm.value.mobile.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.mobile.split("+" + oldcountry)[1] : this.EditForm.value.mobile;
    if (this.setmobile) {
      this.EditForm.controls['mobile'].setValue("+" + obj.dialCode + this.setmobile);
    }
  }

  onMobileTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.setmobile = (this.EditForm.value.mobile == null || this.EditForm.value.mobile == "") ? null : (this.EditForm.value.mobile.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.mobile.split("+" + oldcountry)[1] : this.EditForm.value.mobile;
    if (this.setmobile) {
      this.EditForm.controls['mobile'].setValue("+" + this.homecountryCode + this.setmobile);
    }
  };

  onHomeCountryChange(obj: any) {

    var oldcountry = this.countryCode
    this.homecountryCode = obj.dialCode
    this.sethome = (this.EditForm.value.home == null || this.EditForm.value.home == "") ? null : (this.EditForm.value.home.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.home.split("+" + oldcountry)[1] : this.EditForm.value.home;
    if (this.sethome) {
      this.EditForm.controls['home'].setValue("+" + obj.dialCode + this.sethome);
    }
  }

  onHomeTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.sethome = (this.EditForm.value.home == null || this.EditForm.value.home == "") ? null : (this.EditForm.value.home.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.home.split("+" + oldcountry)[1] : this.EditForm.value.home;
    if (this.sethome) {
      this.EditForm.controls['home'].setValue("+" + this.homecountryCode + this.sethome);
    }
  };

  onWorkCountryChange(obj: any) {
    var oldcountry = this.countryCode
    this.workcountryCode = obj.dialCode
    this.setwork = (this.EditForm.value.work == null || this.EditForm.value.work == "") ? null : (this.EditForm.value.work.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.work.split("+" + oldcountry)[1] : this.EditForm.value.work;
    if (this.setwork) {
      this.EditForm.controls['work'].setValue("+" + obj.dialCode + this.setwork);
    }
  }

  onWorkTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.setwork = (this.EditForm.value.work == null || this.EditForm.value.work == "") ? null : (this.EditForm.value.work.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.work.split("+" + oldcountry)[1] : this.EditForm.value.work;
    if (this.setwork) {
      this.EditForm.controls['work'].setValue("+" + this.homecountryCode + this.setwork);
    }
  };

  getNumber(obj: any) {
    console.log(obj);
  }
  hasError(obj: any) {
    console.log(obj)
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/admin/edit-employee/edit-employee.component.ts